<template>
  <div class="row">
    <div class="col-md-12">
      <b-row>
        <b-col class="col-md-10 text-left">
          <h2>Ocorrências</h2>
        </b-col>
        <b-col class="text-right" align-v="end" v-if="perfil == 'distribuidor'">
          <b-button variant="success" size="sm" @click="novaOcorrencia"><i class="fas fa-plus"></i> Nova Ocorrência
          </b-button>
        </b-col>
      </b-row>
      <b-card>
        <b-row align-v="end" v-show="perfil">
          <b-col>
            <label for="">Ocorrência</label>
            <b-form-input size="sm" v-model="cod_ocorrencia" placeholder="Código"
              @keyup.enter="buscar()"></b-form-input>
          </b-col>
          <b-col v-if="perfil !== 'distribuidor'" class="col-md-2">
            <label for="">Distribuidor</label>
            <b-form-input size="sm" v-model="distribuidor" placeholder="Código ou Nome"
              @keyup.enter="buscar()"></b-form-input>
          </b-col>
          <b-col>
            <label for="">Departamento</label>
            <b-form-select size="sm" v-model="departamento" :options="optionRoles"></b-form-select>
          </b-col>
          <b-col>
            <label for="">Status</label>
            <b-form-select size="sm" v-model="status" :options="optionStatus"></b-form-select>
          </b-col>
          <b-col v-if="perfil !== 'distribuidor'" class="col-md-1">
            <label for="">UF</label>
            <b-form-select size="sm" v-model="uf" :options="optionsUf"></b-form-select>
          </b-col>
          <b-col v-if="perfil !== 'distribuidor'" class="col-md-1">
            <label for="">Classe</label>
            <b-form-select size="sm" v-model="classe" :options="optionsClasse"></b-form-select>
          </b-col>
        </b-row>
        <b-row align-v="end" class="mt-3" v-show="perfil">
          <b-col cols="2" v-if="perfil !== 'distribuidor'">
            <label for="">Analista</label>
            <b-form-select size="sm" v-model="analista" :options="optionsAnalistas"></b-form-select>
          </b-col>
          <b-col class="col-md-2">
            <label class="mb-0" for="">De</label>
            <b-form-datepicker id="de" placeholder="Nenhuma Data" calendar-width="200" label-no-date-selected=""
              label-next-month="Próximo Mês" label-next-year="Próximo Ano" label-prev-month="Mês Anterior"
              label-prev-year="Ano Anterior" label-current-month="Mês Atual" label-help hide-header reset-button
              reset-button-variant="danger" label-reset-button="Limpar" v-model="de" size="sm" :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" locale="pt-BR" />
          </b-col>
          <b-col class="col-md-2">
            <label class="mb-0" for="">Até</label>
            <b-form-datepicker id="ate" placeholder="Nenhuma Data" calendar-width="200" label-no-date-selected=""
              label-next-month="Próximo Mês" label-next-year="Próximo Ano" label-prev-month="Mês Anterior"
              label-prev-year="Ano Anterior" label-current-month="Mês Atual" label-help hide-header reset-button
              reset-button-variant="danger" label-reset-button="Limpar" v-model="ate" size="sm" :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" locale="pt-BR" />
          </b-col>
          <b-col>
            <b-button :disabled="loading" variant="primary" size="sm" @click="buscar()">
              <i class="fas fa-search"></i> Buscar
            </b-button>
            <b-button class="ml-3" :disabled="loading" variant="success" size="sm" v-if="perfil !== 'distribuidor'"
              @click="exportar()">
              <i class="fas fa-file-excel"></i> Exportar
            </b-button>
            <b-button :disabled="loading" variant="secondary" class="ml-3" size="sm" @click="limpar()" title="Limpar Filtros">
              <i class="fas fa-broom"></i>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-pagination v-if="ocorrencias.data.length > 0" v-model="ocorrencias.current_page" align="fill" size="sm"
              :total-rows="ocorrencias.total" :per-page="ocorrencias.per_page" @input="loadOcorrencias()" />
          </b-col>
          <b-col class="col-md-1 text-right">
            <b-form-select size="sm" v-model="perPage" title="Por Página" :options="optionsPerPage"></b-form-select>
          </b-col>
          <b-col class="col-md-1 text-right">
            <div v-if="total > 0">Total: {{ total }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-table striped hover :fields="perfil !== 'distribuidor' ? fieldsAdm : fields" :items="ocorrenciasGet"
            show-empty :busy="loading" empty-text="Nenhuma Ocorrência Encontrada...">
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Buscando Ocorrências ...</strong>
              </div>
            </template>
            <template #cell(status)="row">
              <b-badge :variant="row.item.variant">{{
                row.item.status
              }}</b-badge>
            </template>
            <template #cell(updated_at)="row">
              <b-badge v-if="perfil !== 'distribuidor'" :variant="row.item.variantDate"
                :class="{ blink: row.item.isBlinking }">
                {{ formatarData(row.item.updated_at) }}
              </b-badge>
              <span v-else>
                {{ formatarData(row.item.updated_at) }}
              </span>
            </template>
            <template #cell(departamento_anterior)="row">
              <b-badge variant="light">{{
                row.item.historico && row.item.historico.length > 0
                  ? getDepartamentoAnterior(row.item.historico)
                  : ""
              }}</b-badge>
            </template>
            <template #cell(departamento_atual)="row">
              <b-badge variant="light">{{
                row.item.departamento_atual
              }}</b-badge>
            </template>
            <template #cell(tituloTipo)="row">
              {{ tipoOcorrencia(row.item.tipo) }}
            </template>
            <template #cell(actions)="row">
              <b-button size="sm" variant="primary" @click="verOcorrenciaAdm(row.item.id)" title="Visualizar"
                v-if="perfil != 'distribuidor'">
                <i class="fas fa-comments"></i>
              </b-button>
              <b-button v-else size="sm" variant="primary" title="Visualizar" @click="verOcorrencia(row.item.id)">
                <i class="fas fa-comments"></i>
              </b-button>
            </template>
            <template #cell(historico)="row" v-if="perfil != 'distribuidor'">
              <b-button v-if="row.item.historicoInvertido.length > 0" size="sm" variant="light" title="Historico"
                @click="row.toggleDetails">
                <i class="fas fa-history"></i>
              </b-button>
            </template>
            <template #row-details="row">
              <b-card bg-variant="secondary" v-if="
                row.item.historicoInvertido &&
                row.item.historicoInvertido.length > 0
              ">
                <b-row class="justify-content-md-center" v-if="
                  row.item.historicoInvertido &&
                  row.item.historicoInvertido.length > 0
                ">
                  <div v-for="(h, index) in row.item.historicoInvertido" :key="index">
                    <b-badge variant="primary">{{ h.departamento }}</b-badge>
                    <i class="fas fa-arrow-right ml-3 mr-3" v-if="index < row.item.historicoInvertido.length - 1"></i>
                  </div>
                </b-row>
              </b-card>
            </template>
          </b-table>
        </b-row>
      </b-card>
    </div>
    <v-mensagens-bar :sidebar="sidebar" :ocorrencia="ocorrenciaSelecionada" @update:sidebar="updateSidebar"
      @loadOcorrencias="loadOcorrencias">
    </v-mensagens-bar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cod_ocorrencia: null,
      ocorrenciaSelecionada: {},
      sidebar: false,
      total: 0,
      perPage: 20,
      optionsPerPage: [5, 10, 20, 50, 100],
      currentPage: 1,
      ocorrencias: {
        data: [],
        current_page: 1,
      },
      distribuidor: "",
      status: "nSolucionado",
      de: "",
      ate: "",
      uf: "Todos",
      classe: "Todas",
      optionsClasse: ["Todas", "A", "G", "L", "P"],
      optionsUf: [
        "Todos",
        "AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MS",
        "MT",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO",
      ],
      optionStatus: [
        { value: "nSolucionado", text: "Não Solucionado" },
        { value: "EM ATENDIMENTO", text: "Em Atendimento" },
        { value: "", text: "Todos" },
        { value: "NOVO", text: "Novo" },
        { value: "PENDENTE", text: "Pendente" },
        { value: "SOLUCIONADO", text: "Solucionado" },
        { value: "FECHADO", text: "Fechado" },
        { value: "CANCELADA", text: "Cancelada" },
      ],
      departamento: "",
      optionRoles: [
        { value: "QUALIDADE", text: "QUALIDADE" },
        { value: "QUALIDADE_LOGISTICA", text: "QUALIDADE_LOGISTICA" },
        { value: "COMERCIAL", text: "COMERCIAL" },
        { value: "", text: "TODOS" },
        { value: "EXPEDICAO", text: "EXPEDICAO" },
        { value: "TRANSPORTE", text: "TRANSPORTE" },
      ],
      fields: [
        { label: "", key: "actions" },
        { label: "Código", key: "id", class: "text-center" },
        { label: "Titulo", key: "tituloTipo" },
        { label: "Lote", key: "lote.codigo" },
        { label: "Status", key: "status", class: "text-center" },
        { label: "Em Tratativa Por", key: "departamento_atual", class: "text-center" },
        {
          label: "Criação", key: "created_at", class: "text-center",
          formatter: (value) => {
            return value ? moment(value).format("DD/MM/YY HH:mm:ss") : "";
          },
        },
        {
          label: "Atualização", key: "updated_at", class: "text-center",
          formatter: (value) => {
            return value ? moment(value).format("DD/MM/YY HH:mm:ss") : "";
          },
        },
      ],
      fieldsAdm: [
        { label: "", key: "actions" },
        { label: "", key: "historico" },
        { label: "Código", key: "id", class: "text-center" },
        { label: "Titulo", key: "tituloTipo" },
        { label: "Lote", key: "lote.codigo" },
        { label: "Status", key: "status", class: "text-center" },
        {
          label: "Distribuidor", key: "distribuidor",
          formatter: (value) => {
            return value.codigo + " - " + value.nome;
          },
        },
        { label: "Classe", key: "distribuidor.classe", class: "text-center" },
        { label: "UF", key: "distribuidor.endereco.cidade.estado.uf", class: "text-center" },
        { label: "Analista", key: "analista.name" },
        { label: "Departamento anterior", key: "departamento_anterior", class: "text-center" },
        { label: "Departamento atual", key: "departamento_atual", class: "text-center" },
        { label: "Atualização", key: "updated_at", class: "text-center" },
      ],
      loading: false,
      perfil: "",
      optionsOc: [],
      analistas: [],
      analista: ""
    };
  },

  async mounted() {
    await this.loadOcorrencias();
    this.getTipoOcorrencias();
    if (this.perfil == "distribuidor") {
      this.status = "";
      await this.loadOcorrencias();
    }
  },
  computed: {
    optionsAnalistas() {
      let data = [{ value: "", text: "TODAS" }];
      this.analistas.forEach((el) => {
        data.push({
          value: el.id,
          text: el.name
        })
      })
      return data
    },
    ocorrenciasGet() {
      return this.ocorrencias.data;
    },
  },
  methods: {
    limpar() {
        this.cod_ocorrencia = '';
        this.distribuidor = '';
        this.departamento = '';
        this.status = 'nSolucionado';
        this.uf = 'Todos';
        this.classe = 'Todas';
        this.analista = '';
        this.de = '';
        this.ate = '';
      },
    exportar() {
      const data = {
        departamento: this.departamento,
        codigo: this.cod_ocorrencia,
        distribuidor: this.distribuidor,
        status: this.status,
        classe: this.classe,
        uf: this.uf,
        analista: this.analista,
        de: this.de,
        ate: this.ate,
      };
      axios
        .get("/ocorrencia/get/link-export", { params: data })
        .then((response) => {
          window.open('/ocorrencia/export/' + response.data.resource, '_blank');
        }).catch((error) => {
          console.log(error)
        }).finally(() => {

        })
    },
    tipoOcorrencia(tipoOc) {
      const vm = this;
      let tipo = null;
      if (vm.optionsOc.length > 0) {
        tipo = vm.optionsOc.find((el) => el.value == tipoOc)
      }
      return tipo && tipo.text ? tipo.text : "";
    },
    getTipoOcorrencias() {
      const vm = this;
      axios.get('/ocorrencia/get/tipo-ocorrencia')
        .then((response) => {
          vm.analistas = response.data.analistas;
          response.data.tipos.forEach((el) => {
            vm.optionsOc.push(el);
          })
        }).catch((error) => {
          console.log(error);
        })
    },
    getHistorico(historico) {
      return historico.reverse();
    },
    getDepartamentoAnterior(historico) {
      let departamento = "";
      if (historico[1]) {
        departamento =
          historico[1].departamento !== "NOVO"
            ? historico[1].departamento
            : "COMERCIAL";
      }
      return departamento;
    },
    updateSidebar(newVal) {
      this.sidebar = newVal;
    },
    buscar() {
      this.ocorrencias = {
        data: [],
        current_page: 1,
      };
      this.loadOcorrencias();
    },
    novaOcorrencia() {
      window.location.href = "/ocorrencia/novo";
    },
    async loadOcorrencias() {
      const vm = this;
      vm.loading = true;
      const data = {
        departamento: this.departamento,
        codigo: this.cod_ocorrencia,
        distribuidor: this.distribuidor,
        status: this.status,
        de: this.de,
        ate: this.ate,
        page: this.ocorrencias.current_page,
        perPage: this.perPage,
        classe: this.classe,
        uf: this.uf,
        analista: this.analista
      };
      await axios
        .get("/adm/ocorrencia/get-ocorrencias", { params: data })
        .then((response) => {
          vm.ocorrencias = response.data.ocorrencias;
          vm.perfil = response.data.perfil;
          vm.total = response.data.ocorrencias.total;
          vm.ocorrencias.data.forEach((el) => {
            el.historicoInvertido = [];
            if (el.historico.length > 0) {
              el.historicoInvertido = el.historico.reverse();
            }
            if (el.status === "NOVO") el.variant = "success";
            else if (el.status === "PENDENTE") el.variant = "warning";
            else if (el.status === "SOLUCIONADO") el.variant = "primary";
            else if (el.status === "FECHADO") el.variant = "dark";
            else if (el.status === "EM ATENDIMENTO") el.variant = "third";
            else if (el.status === "CANCELADA") el.variant = "danger";

            el.variantDate = "light";
            el.isBlinking = false;
            if (              
              vm.perfil !== "distribuidor" &&
              (el.status !== 'SOLUCIONADO' && el.status !== 'FECHADO' && el.status !== 'CANCELADA') &&
              (el.departamento_atual == "TRANSPORTE" ||
                el.departamento_atual == "EXPEDICAO" ||
                el.departamento_atual == "COMERCIAL" ||
                el.departamento_atual == "QUALIDADE" ||
                el.departamento_atual == "QUALIDADE_LOGISTICA")
            ) {
              const agora = moment();
              if (
                moment(el.updated_at).isBefore(
                  moment(agora).subtract(2, "hours")
                )
              ) {
                el.variantDate = "danger";
                el.isBlinking = true;
              } else if (
                moment(el.updated_at).isBefore(
                  moment(agora).subtract(1, "hours")
                )
              ) {
                el.variantDate = "warning";
              } else {
                el.variantDate = "success";
              }
            }
          });
        })
        .catch((erro) => {
          console.log(erro);
        })
        .finally(() => {
          vm.loading = false;
        });
    },
    verOcorrenciaAdm(id) {
      if (this.sidebar) {
        this.sidebar = false;
      }
      const vm = this;
      const params = {
        adm: true,
      };

      $(".loading").show();

      axios
        .get("/ocorrencia/" + id, { params: params })
        .then((response) => {
          // console.log(response.data.ocorrencia)
          vm.ocorrenciaSelecionada = response.data.ocorrencia;
          vm.ocorrenciaSelecionada.perfil = response.data.perfil;
          vm.sidebar = true;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          $(".loading").hide();
        });
    },
    verOcorrencia(id) {
      window.location.href = "/ocorrencia/" + id;
    },
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },
    
  },
};
</script>

<style>
@keyframes blink {
  20% {
    opacity: 1;
  }

  60% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.blink {
  animation: blink 1s infinite;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ocorrencia/List.vue